import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

// UI preference only — never store tokens or secrets in localStorage.
export const THEME_KEY = "toastern_theme";
const ThemeContext = createContext(null);

const apply = (theme) => {
  document.documentElement.classList.toggle("dark", theme === "dark");
  document.documentElement.style.colorScheme = theme;
};

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => (localStorage.getItem(THEME_KEY) === "dark" ? "dark" : "light"));

  useEffect(() => {
    apply(theme);
  }, [theme]);

  const setTheme = useCallback((next) => {
    localStorage.setItem(THEME_KEY, next);
    setThemeState(next);
  }, []);

  const toggle = useCallback(() => setTheme(theme === "dark" ? "light" : "dark"), [theme, setTheme]);

  const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, setTheme, toggle]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
